module.exports = __webpack_public_path__ + "img/UnderMaintenance2.c5777012.png";